<script>

import { InputNumber } from 'element-ui'
export default {
  name: 'CargoElInputNumber',
  extends: InputNumber,
  watch: {
    displayValue(val) {
      if (val) {
        this.$refs.input.$refs.input && this.$refs.input.$refs.input.setAttribute('title', val)
      } else {
        this.$refs.input.$refs.input && this.$refs.input.$refs.input.removeAttribute('title')
      }
    }
  },
  mounted() {
    const innerInput = this.$refs.input.$refs.input
    innerInput.setAttribute('role', 'spinbutton')
    innerInput.setAttribute('aria-valuemax', this.max)
    innerInput.setAttribute('aria-valuemin', this.min)
    innerInput.setAttribute('aria-valuenow', this.currentValue)
    innerInput.setAttribute('aria-disabled', this.inputNumberDisabled)
    innerInput.setAttribute('title', this.displayValue)
  }
}
</script>
